import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BRAND } from "../lib/brand";
import { Phone } from "lucide-react";

/**
 * MobileStickyCta - persistent Call + Free Estimate bar on small screens only.
 * Hidden on lg+ (nav phone/CTA already visible). Hides while typing in the
 * quote form and briefly on scroll-up.
 */
export default function MobileStickyCta() {
  const [visible, setVisible] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onFocus = (e) => {
      const tag = (e.target?.tagName || "").toUpperCase();
      if (["INPUT", "TEXTAREA", "SELECT"].includes(tag)) setVisible(false);
    };
    const onBlur = () => setVisible(true);
    document.addEventListener("focusin", onFocus);
    document.addEventListener("focusout", onBlur);
    return () => {
      document.removeEventListener("focusin", onFocus);
      document.removeEventListener("focusout", onBlur);
    };
  }, []);

  const goQuote = (e) => {
    e.preventDefault();
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        const el = document.getElementById("quote");
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } else {
      document.getElementById("quote")?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div
      data-testid="mobile-sticky-cta"
      className={`md:hidden fixed inset-x-0 bottom-0 z-30 transition-transform duration-300 ${
        visible ? "translate-y-0" : "translate-y-full"
      }`}
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="mx-3 mb-3 rounded-2xl bg-white border border-neutral-200 shadow-[0_-6px_30px_-10px_rgba(15,15,25,0.25)] flex items-stretch overflow-hidden">
        <a
          href={`tel:${BRAND.phoneTel}`}
          data-testid="sticky-call-btn"
          className="flex-1 flex items-center justify-center gap-2 py-3 font-bebas text-xl tracking-wide text-[color:var(--dbe-red)] active:bg-neutral-50"
        >
          <Phone className="w-5 h-5" strokeWidth={2.5} /> Call Us
        </a>
        <a
          href="/#quote"
          onClick={goQuote}
          data-testid="sticky-estimate-btn"
          className="flex-1 flex items-center justify-center gap-2 py-3 bg-[color:var(--dbe-red)] text-white font-bold uppercase tracking-wider text-sm active:bg-[color:var(--dbe-red-deep)]"
        >
          Free Estimate <i className="fa-solid fa-arrow-right text-xs" />
        </a>
      </div>
    </div>
  );
}
